import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, vShow as _vShow, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["data-forma", "onKeydown"]
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "assistente-dock__rotulo" }
const _hoisted_4 = { class: "assistente-dock__acionador-texto" }
const _hoisted_5 = { class: "assistente-dock__foto" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["aria-label", "title"]
const _hoisted_8 = ["aria-label", "placeholder", "disabled"]
const _hoisted_9 = ["aria-label", "disabled"]
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = ["aria-label"]
const _hoisted_12 = { class: "assistente-dock__cabecalho" }
const _hoisted_13 = { class: "assistente-dock__identidade" }
const _hoisted_14 = { class: "assistente-dock__titulo" }
const _hoisted_15 = { class: "assistente-dock__acoes" }
const _hoisted_16 = ["id", "role", "aria-labelledby", "inert"]
const _hoisted_17 = {
  class: "assistente-dock__anuncio",
  "aria-live": "polite"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["assistente-dock", [`assistente-dock--${$setup.forma}`, { 'assistente-dock--com-suporte': $setup.suporteVisivel }]]),
    "data-forma": $setup.forma,
    "data-assistente-ignorar": "",
    onKeydown: _withKeys(_withModifiers($setup.aoPressionarEscape, ["stop","prevent"]), ["esc"])
  }, [
    ($setup.forma === 'minimizado' && $setup.larguraDaJanela >= 1024)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "assistente-dock__acionador",
          "data-testid": "assistente-dock-acionador",
          "aria-label": $setup.t('assistentePontotel.titulo'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.mudarIntencao('acionar')))
        }, [
          _createElementVNode("span", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString($setup.t('assistentePontotel.titulo')), 1 /* TEXT */)
          ]),
          _createElementVNode("span", _hoisted_5, [
            _createElementVNode("img", {
              src: $setup.fotoNina,
              alt: "",
              width: "56",
              height: "56"
            }, null, 8 /* PROPS */, _hoisted_6),
            _cache[18] || (_cache[18] = _createElementVNode("span", {
              class: "assistente-dock__selo",
              "aria-hidden": "true"
            }, [
              _createElementVNode("span", { class: "assistente-dock__estrela" })
            ], -1 /* CACHED */))
          ])
        ], 8 /* PROPS */, _hoisted_2))
      : ($setup.forma === 'recolhido' && $setup.larguraDaJanela >= 1024)
        ? (_openBlock(), _createElementBlock("form", {
            key: 1,
            class: "assistente-dock__pergunta",
            "data-testid": "assistente-dock-pergunta",
            onSubmit: _withModifiers($setup.enviarPerguntaRecolhida, ["prevent"])
          }, [
            _createCommentVNode("\n        Sem isto a pílula é rua de mão única: dá para perguntar de novo, mas\n        não para voltar ao que já foi conversado. O gesto `expandir` sempre\n        existiu no domínio; faltava quem o disparasse.\n      "),
            _createElementVNode("button", {
              type: "button",
              class: "assistente-dock__expandir",
              "data-testid": "assistente-dock-expandir",
              "aria-label": $setup.t('assistentePontotel.acoes.abrirConversa'),
              title: $setup.t('assistentePontotel.acoes.abrirConversa'),
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.mudarIntencao('expandir')))
            }, [...(_cache[19] || (_cache[19] = [
              _createElementVNode("span", {
                class: "assistente-dock__estrela",
                "aria-hidden": "true"
              }, null, -1 /* CACHED */)
            ]))], 8 /* PROPS */, _hoisted_7),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.perguntaRecolhida) = $event)),
              "data-testid": "assistente-dock-input",
              type: "text",
              "aria-label": $setup.t('assistentePontotel.composer.ariaLabel'),
              placeholder: $setup.t('assistentePontotel.composer.placeholder'),
              disabled: $setup.props.loading === true || $setup.selecaoPendente
            }, null, 8 /* PROPS */, _hoisted_8), [
              [_vModelText, $setup.perguntaRecolhida]
            ]),
            _createElementVNode("button", {
              type: "submit",
              "data-testid": "assistente-dock-enviar",
              "aria-label": $setup.t('assistentePontotel.composer.enviar'),
              disabled: $setup.props.loading === true || $setup.selecaoPendente || !$setup.perguntaRecolhida.trim()
            }, [...(_cache[20] || (_cache[20] = [
              _createElementVNode("span", { "aria-hidden": "true" }, "↑", -1 /* CACHED */)
            ]))], 8 /* PROPS */, _hoisted_9),
            _createElementVNode("button", {
              type: "button",
              class: "assistente-dock__fechar-pergunta",
              "aria-label": $setup.t('assistentePontotel.acoes.fechar'),
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.mudarIntencao('fechar')))
            }, [...(_cache[21] || (_cache[21] = [
              _createElementVNode("span", { "aria-hidden": "true" }, "×", -1 /* CACHED */)
            ]))], 8 /* PROPS */, _hoisted_10)
          ], 32 /* NEED_HYDRATION */))
        : _createCommentVNode("v-if", true),
    ($setup.conversaMontada)
      ? _withDirectives((_openBlock(), _createElementBlock("section", {
          key: 2,
          ref: "painelDaConversa",
          tabindex: "-1",
          class: _normalizeClass(["assistente-dock__painel", { 'assistente-dock__painel--abas': $setup.props.conversaEmAbas }]),
          "aria-label": $setup.t('assistentePontotel.titulo')
        }, [
          _createCommentVNode("\n        N6 — o histórico mora aqui, e não no cabeçalho do canvas.\n        Histórico de conversa é assunto da CONVERSA; hospedá-lo no canvas\n        obrigava o canvas a existir para se chegar nele, e foi o que me fez\n        (G6) manter 72px de cabeçalho vivo só para não perder a porta. Com a\n        porta aqui, o canvas vazio pode colapsar de verdade.\n      "),
          _createElementVNode("header", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, [
              _cache[22] || (_cache[22] = _createElementVNode("span", {
                class: "assistente-dock__estrela",
                "aria-hidden": "true"
              }, null, -1 /* CACHED */)),
              _createElementVNode("span", _hoisted_14, _toDisplayString($setup.t('assistentePontotel.titulo')), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createCommentVNode("\n            \"Nova conversa\" vira ícone aqui, ao lado do histórico: as três\n            ações da conversa — começar outra, rever as anteriores, fechar —\n            passam a morar no mesmo lugar, e a coluna recupera a linha que o\n            botão de texto ocupava. O de texto continua existindo na PÁGINA\n            cheia, onde há largura de sobra e nenhum cabeçalho de dock.\n\n            Antes dele, as opções avançadas — só quando o agente manda exibir.\n          "),
              ($setup.props.opcoesAvancadas?.exibir === true)
                ? (_openBlock(), _createBlock($setup["OpcoesAvancadas"], {
                    key: 0,
                    opcoes: $setup.props.opcoesAvancadas,
                    "onUpdate:modoDeAcao": _cache[4] || (_cache[4] = ($event: any) => ($setup.emit('update:modo-de-acao', $event)))
                  }, null, 8 /* PROPS */, ["opcoes"]))
                : _createCommentVNode("v-if", true),
              _createVNode($setup["PontotelBotaoIcone"], {
                "data-testid": "assistente-dock-nova-conversa",
                tamanho: "P",
                tipo: "neutro",
                peso: "intermediario",
                desabilitado: $setup.props.loading === true,
                "aria-label": $setup.t('assistentePontotel.acoes.novaConversa'),
                title: $setup.t('assistentePontotel.acoes.novaConversa'),
                onClique: _cache[5] || (_cache[5] = ($event: any) => ($setup.emit('nova-conversa')))
              }, {
                icone: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                  _createElementVNode("svg", {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    "aria-hidden": "true"
                  }, [
                    _createElementVNode("path", {
                      d: "M12 5v14M5 12h14",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round"
                    })
                  ], -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["desabilitado", "aria-label", "title"]),
              _createVNode($setup["PontotelBotaoIcone"], {
                "data-testid": "assistente-dock-historico",
                tamanho: "P",
                tipo: "neutro",
                peso: "intermediario",
                "aria-label": $setup.t('assistentePontotel.historico.titulo'),
                title: $setup.t('assistentePontotel.historico.titulo'),
                onClique: _cache[6] || (_cache[6] = ($event: any) => ($setup.emit('history')))
              }, {
                icone: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                  _createElementVNode("svg", {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    "aria-hidden": "true"
                  }, [
                    _createElementVNode("path", {
                      d: "M9 6h11M9 12h11M9 18h11M4 6h1M4 12h1M4 18h1",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round"
                    })
                  ], -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["aria-label", "title"]),
              ($setup.props.context?.role === 'gestor' || $setup.props.context?.role === 'rh')
                ? (_openBlock(), _createBlock($setup["PontotelBotaoIcone"], {
                    key: 1,
                    "data-testid": "assistente-dock-politicas",
                    tamanho: "P",
                    tipo: "neutro",
                    peso: "intermediario",
                    "aria-label": $setup.t('assistentePontotel.politicasDeIa.abrir'),
                    title: $setup.t('assistentePontotel.politicasDeIa.abrir'),
                    onClique: _cache[7] || (_cache[7] = ($event: any) => ($setup.emit('politicas')))
                  }, {
                    icone: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                      _createElementVNode("svg", {
                        viewBox: "0 0 24 24",
                        fill: "none",
                        "aria-hidden": "true"
                      }, [
                        _createElementVNode("path", {
                          d: "M4 5.5A2.5 2.5 0 0 1 6.5 3H20v14H6.5A2.5 2.5 0 0 0 4 19.5v-14Z",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linejoin": "round"
                        }),
                        _createElementVNode("path", {
                          d: "M4 19.5A2.5 2.5 0 0 0 6.5 22H20v-5",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linejoin": "round"
                        }),
                        _createElementVNode("path", {
                          d: "M8.5 8h6",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round"
                        })
                      ], -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["aria-label", "title"]))
                : _createCommentVNode("v-if", true),
              _createVNode($setup["PontotelBotaoIcone"], {
                "data-testid": "assistente-dock-fechar",
                tamanho: "P",
                tipo: "neutro",
                peso: "intermediario",
                "aria-label": $setup.t('assistentePontotel.acoes.fechar'),
                title: $setup.t('assistentePontotel.acoes.fechar'),
                onClique: _cache[8] || (_cache[8] = ($event: any) => ($setup.mudarIntencao('fechar')))
              }, {
                icone: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                  _createElementVNode("svg", {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    "aria-hidden": "true"
                  }, [
                    _createElementVNode("path", {
                      d: "m6 6 12 12M18 6 6 18",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round"
                    })
                  ], -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["aria-label", "title"])
            ])
          ]),
          _renderSlot(_ctx.$slots, "abas", {}, undefined, true),
          _withDirectives(_createElementVNode("div", {
            id: $setup.props.conversaEmAbas ? 'resultado-conversa' : undefined,
            role: $setup.props.conversaEmAbas ? 'tabpanel' : undefined,
            "aria-labelledby": $setup.props.conversaEmAbas ? 'aba-conversa' : undefined,
            inert: $setup.props.conversaOculta,
            class: "assistente-dock__conteudo"
          }, [
            _createVNode($setup["ConversationPane"], {
              messages: $setup.mensagens,
              "resultados-por-id": $setup.props.resultadosPorId,
              "resultado-ativo-id": $setup.props.resultadoAtivoId,
              "resultado-visivel": $setup.props.resultadoVisivel,
              context: $setup.contexto,
              loading: $setup.props.loading === true,
              compacto: true,
              "leitura-da-tela-autorizada": $setup.props.leituraDaTelaAutorizada === true,
              onSend: $setup.despacharEnvio,
              onNovaConversa: _cache[9] || (_cache[9] = ($event: any) => ($setup.emit('nova-conversa'))),
              onPreview: _cache[10] || (_cache[10] = ($event: any) => ($setup.emit('preview', $event))),
              onAbrirResultado: _cache[11] || (_cache[11] = ($event: any) => ($setup.emit('abrir-resultado', $event))),
              onAbrirNavegacao: _cache[12] || (_cache[12] = ($event: any) => ($setup.emit('abrir-navegacao', $event))),
              onAceitarOfertaDeSuporte: _cache[13] || (_cache[13] = ($event: any) => ($setup.emit('aceitar-oferta-de-suporte', $event))),
              onSelecionarOpcao: _cache[14] || (_cache[14] = ($event: any) => ($setup.emit('selecionar-opcao', $event))),
              onResponderSolicitacaoDeParametros: _cache[15] || (_cache[15] = ($event: any) => ($setup.emit('responder-solicitacao-de-parametros', $event))),
              onAvaliarResposta: _cache[16] || (_cache[16] = ($event: any) => ($setup.emit('avaliar-resposta', $event))),
              onExecutarPlanejamento: _cache[17] || (_cache[17] = ($event: any) => ($setup.emit('executar-planejamento', $event)))
            }, null, 8 /* PROPS */, ["messages", "resultados-por-id", "resultado-ativo-id", "resultado-visivel", "context", "loading", "leitura-da-tela-autorizada"])
          ], 8 /* PROPS */, _hoisted_16), [
            [_vShow, !$setup.props.conversaOculta]
          ])
        ], 10 /* CLASS, PROPS */, _hoisted_11)), [
          [_vShow, $setup.forma === 'acoplado' || $setup.forma === 'sobreposto']
        ])
      : _createCommentVNode("v-if", true),
    _createElementVNode("p", _hoisted_17, _toDisplayString($setup.anuncioDaForma), 1 /* TEXT */)
  ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1))
}